export default {
  authStatus: (state) => state.status,
  user: (state) => state.user,
  userId: (state) => state.user?.id,
  twoFactorSetup: (state) => state.twoFactorSetup,
  hasPendingTwoFactorSetup: (state) => {
    const setup = state.twoFactorSetup || {};
    return setup.setupRequired === true || (setup.required === true && setup.completed !== true);
  },
  access: (state) => state.access,
  primaryScopeIds: (state) => state.primaryScopeIds,
  primaryTenantIds: (state) => state.primaryTenantIds,
  tenantId: (state) => state.tenantId,
};
